import api from './api';
import { appInsights } from '../services/ApplicationInsightsService';
import { AnalysisType } from '../types/AnalysisType';

export const uploadAudioFile = async (file: File, analysisType: string): Promise<any> => {
    const formData = new FormData();
    formData.append('audioFile', file);
    formData.append('AnalysisTypeCode', analysisType); // Include AnalysisTypeCode

    try {
        const response = await api.post('/api/v1/audio/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (error) {
        appInsights.trackException({ exception: error as Error });
        throw error;
    }
};

export const getAnalysisTypes = async (): Promise<AnalysisType[]> => {
    try {
        const response = await api.get('/api/v1/AnalysisType');
        return response.data;
    } catch (error) {
        appInsights.trackException({ exception: error as Error });
        throw error;
    }
};

export const uploadAudioChunk = async (audioBlob: Blob, analysisType: string): Promise<any> => {
    const formData = new FormData();
    formData.append('audioBlob', audioBlob);
    formData.append('analysisTypeCode', analysisType);

    try {
        const response = await api.post('/api/v1/audio/chunk', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (error) {
        appInsights.trackException({ exception: error as Error });
        throw error;
    }
};

export const uploadVTTFile = async (file: File, analysisType: string): Promise<any> => {
    const formData = new FormData();
    formData.append('transcriptFile', file);
    formData.append('AnalysisTypeCode', analysisType);

    try {
        const response = await api.post('/api/v1/transcription/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        appInsights.trackException({ exception: error as Error });
        throw error;
    }
};

export const clearSession = async (): Promise<any> => {
    try {
        const response = await api.delete('/api/v1/audio/session/');
        return response.data;
    } catch (error) {
        appInsights.trackException({ exception: error as Error });
        throw error;
    }
};